import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import http from './http'
import VDistpicker from 'v-distpicker'
//import aliplayer from "aliplayer";

Vue.prototype.$http = http

Vue.use(ElementUI);
//Vue.use(aliplayer);

Vue.config.productionTip = false
Vue.component('v-distpicker', VDistpicker)


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')